module.exports = __webpack_public_path__ + "static/media/navidad10.f3f1c1fc.jpg";